// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2shg3","title":"styles_title__wnOcI"};